import '../legacy_jquery'

let ready_batch_visitor;

ready_batch_visitor = function () {
  let addCheckbox, allow_inputs_for_client, loadPermissions;
  $("body").on("change", "select.batch_visitor-dc-select", function () {
    var container, rows;
    container = $('.visitor_container');
    rows = container.find('.fields');
    return loadPermissions(container, rows);
  });
  $("body").on("change", "fieldset.create_batch_visitor_request_visitor_type", function () {
    let container, is_allow_client_inputs, rows;
    container = $('.visitor_container');
    rows = container.find('.fields');
    loadPermissions(container, rows);
    is_allow_client_inputs = $(this).find("input[value=client]").is(':checked');
    return allow_inputs_for_client(is_allow_client_inputs);
  });
  loadPermissions = function (container, rows) {
    let data_center, fieldset;
    data_center = $('select.batch_visitor-dc-select').val();
    fieldset = container.find('fieldset');
    fieldset.find('div.form-check').remove();
    if ($("form").find("input[value=client]").is(':checked') && data_center.length) {
      return $.ajax({
        url: '/admin/acs/visitors/permissions.json',
        type: 'GET',
        data: {
          q: {
            kind_eq: 1,
            data_center_permissions_data_center_id_in: data_center
          }
        },
        contentType: 'application/json; charset=utf-8'
      }).done(function (response) {
        return $.each(response, function (i, item) {
          return rows.each(function () {
            return addCheckbox(item, $(this));
          });
        });
      });
    }
  };
  addCheckbox = function (item, row) {
    let container, div, id, index, inputs, label;
    container = row.find('.batch_visitor_permission').find('fieldset');
    index = row.data('index');
    inputs = container.find('input');
    id = index + inputs.length + 1;
    div = $('<div />', {
      class: 'form-check'
    }).appendTo(container);
    $('<input />', {
      type: 'checkbox',
      class: 'form-check-input is-valid check_boxes optional',
      id: 'permission_' + index + '_' + id,
      name: 'create_batch_visitor_request[create_visitor_requests_attributes][' + index + '][permission_ids][]',
      value: item.id
    }).appendTo(div);
    label = $('<label />', {
      class: 'collection_check_boxes',
      'for': 'permission_' + index + '_' + id
    }).appendTo(div);
    label.append(" " + item.name);
    console.log(item);
    return $.each(item.data_center_names, function (i, data_center_name) {
      return label.append(" [" + data_center_name + "]");
    });
  };
  window.addVisitorFields = function (link, hide_button, id, association, content) {
    let html;
    html = add_fields(link, hide_button, id, association, content);
    return loadPermissions(html, html);
  };
  return allow_inputs_for_client = function (is_allow) {
    $('.batch_visitor_date').prop("disabled", !is_allow).val("");
    $('.batch_visitor-dc-select').prop("disabled", !is_allow).val("");
    return $('.batch_visitor-dc-select').selectpicker('refresh');
  };
};

$(document).ready(ready_batch_visitor);

$(document).on('turbo:load', ready_batch_visitor);
